import React, { useEffect } from 'react';
import AttendanceRecordTotalDataTable from './AttendanceRecordTotalDataTable';

const AttendanceRecordTotalIndex = ({ rrhh }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <AttendanceRecordTotalDataTable rrhh={rrhh} />;
};

export default AttendanceRecordTotalIndex;
